/* eslint-disable @typescript-eslint/no-unused-vars */
import * as S from "../styles";

import { useEffect, useState } from "react";
import { Dialog, DialogActions, DialogContent, DialogTitle, Grid } from "@mui/material";
import { Button } from "@mui/material";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";

import AutoCompleteMult from "@/components/hookForms/autoCompleteMult";
import CheckBox from "@/components/hookForms/checkbox";
import CloseIcon from "@mui/icons-material/Close";
import IGenericResult from "@/interfaces/IGenericResult";
import IconButton from "@mui/material/IconButton";
import messages from "@/utils/messages";
import serviceConcessionaria from "@/services/serviceConcessionaria";
import serviceRelatorio from "@/services/serviceRelatorio";
import serviceRebalanceUsina from "@/services/serviceRebalanceUsina";
import { statusFilterOptions, statusOptions, tipoRebateFilterOptions } from "@/utils/constants";
import AutoComplete from "@/components/hookForms/autoComplete";
import { LoadingButton } from "@mui/lab";

export interface IDialogProps {
    open: boolean;
    onClose?: any;
}

export default function ParametrosRebate({ open, onClose }: IDialogProps) {
    const [usinaDataOptions, setUsinaDataOptions] = useState<IGenericResult[]>([]);
    const [parametrizacaoDataOptions, _setParametrizacaoDataOptions] = useState<IGenericResult[]>([]);
    const [concessionariaDataOptions, setConcessionariaDataOptions] = useState<IGenericResult[]>([]);
    const [disabled, setDisabled] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const history = useHistory();

    const {
        control,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm({
        defaultValues: {
            IdsParametrizacoes: "",
            idsConcessionarias: "",
            idsUsinas: "",
            tipoRebate: "",
            ativo: "",
        },
    });

    useEffect(() => {
        setConcessionariaData();
    }, []);

    const getUsinaData = async (values: any) => {
        if (values.concessionariaID) {
            serviceRebalanceUsina
                .getUsinasByConcessionaria(values)
                .then((result) => {
                    if (result) {
                        setUsinaDataOptions(result?.data);
                    }
                })
                .catch(() => {
                    setUsinaDataOptions([]);
                });
        }
    };

    const setConcessionariaData = async () => {
        serviceConcessionaria
            .getConcessionarias()
            .then((result) => {
                setConcessionariaDataOptions(result?.data);
            })
            .catch(() => {
                setConcessionariaDataOptions([]);
            });
    };

    const onSubmit = (values: any) => {
        setDisabled(true);
        setLoading(true);

        const newValues = {
            ...values,
            relatorioTipoID: 20,
            IdsParametrizacoes: values.IdsParametrizacoes ? values.IdsParametrizacoes.join(", ") : "",
            idsConcessionarias: values.idsConcessionarias ? values.idsConcessionarias.join(", ") : "",
            idsUsinas: values.idsUsinas ? values.idsUsinas.join(", ") : "",
            ativo: typeof statusFilterOptions[values.ativo] !== "boolean" ? "" : statusFilterOptions[values.ativo],
        };

        serviceRelatorio
            .getRelatorioParametrizacaoRebate(newValues)
            .then((result) => {
                if (result) {
                    onClose();
                    toast.success(messages.reportSucess);
                }
            })
            .catch(() => {
                toast.error(messages.reportError);
            })
            .finally(() => {
                setDisabled(false);
                setLoading(false);
                if (newValues.redirecionar) {
                    history.push("/relatorios/listagemrelatorios");
                }
            });
    };

    return (
        <div>
            <Dialog
                maxWidth="md"
                fullWidth
                onClose={(_, reason) => {
                    if (reason !== "backdropClick") {
                        onClose();
                    }
                }}
                open={open}
            >
                <DialogTitle>
                    <S.Title>Gerar relatório: Parâmetros Rebate</S.Title>
                    <IconButton
                        aria-label="close"
                        onClick={() => {
                            reset();
                            onClose(onclose);
                        }}
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <DialogContent dividers>
                        <Grid container>
                            <Grid item xs={12} md={12}>
                                <AutoCompleteMult
                                    name="IdsParametrizacoes"
                                    label="ID"
                                    options={parametrizacaoDataOptions}
                                    control={control}
                                    error={errors}
                                    concatWithID={true}
                                />
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <AutoCompleteMult
                                    name="idsConcessionarias"
                                    label="Concessionarias"
                                    options={concessionariaDataOptions}
                                    control={control}
                                    error={errors}
                                    onChange={(idConcessionaria) => {
                                        if (idConcessionaria) {
                                            getUsinaData({ concessionariaID: idConcessionaria });
                                        }
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <AutoCompleteMult
                                    name="idsUsinas"
                                    label="Usina"
                                    options={usinaDataOptions}
                                    control={control}
                                    error={errors}
                                />
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <AutoComplete
                                    name="tipoRebate"
                                    label="Tipo Rebate"
                                    options={tipoRebateFilterOptions}
                                    control={control}
                                    error={errors}
                                />
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <AutoComplete
                                    name="ativo"
                                    label="Status"
                                    options={statusOptions}
                                    control={control}
                                    error={errors}
                                />
                            </Grid>
                            <Grid item xs={12} md={12}>
                                <CheckBox
                                    name="redirecionar"
                                    label="Redirecionar para a tela de relatório"
                                    control={control}
                                    error={errors}
                                />
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions style={{ display: "flex", justifyContent: "center", margin: "24px" }}>
                        <Button
                            style={{ width: "159px", height: "44px" }}
                            onClick={() => {
                                reset();
                                onClose(onClose);
                            }}
                            color="warning"
                            variant="contained"
                        >
                            Cancelar
                        </Button>
                        <LoadingButton
                            loading={isLoading}
                            disabled={disabled}
                            style={{ width: "159px", height: "44px" }}
                            onClick={() => {}}
                            type="submit"
                            variant="contained"
                        >
                            Gerar
                        </LoadingButton>
                    </DialogActions>
                </form>
            </Dialog>
        </div>
    );
}
